"use client";

import { useState, useEffect } from 'react';
import { FormattedMessage } from "react-intl";
import Cookies from "js-cookie";

import { initClarity } from "@/helpers/Clarity";
import { initGoogleTag } from "@/helpers/GoogleTag";

const ConsentDialog = () => {
  const [showDialog, setShowDialog] = useState(false);

  const handleAccept = () => {
    Cookies.set("clarityConsent", true, {
      expires: 365,
      domain: ".downfor.life"
    });
    initClarity();
    initGoogleTag();
    setShowDialog(false);
  };

  const handleDecline = () => {
    Cookies.set("clarityConsent", false, {
      expires: 365,
      domain: ".downfor.life"
    });
    setShowDialog(false);
  };

  useEffect(() => {
    const consentGiven = Cookies.get("clarityConsent");

    if (!consentGiven) {
      setShowDialog(true);
    } else if (consentGiven === "true") {
      initClarity();
      initGoogleTag();
    }
  }, []);

  return (
    showDialog && (
      <div class="fixed bottom-[20px] inset-x-0 flex justify-center z-50">
        <div class="bg-white rounded-2xl shadow-xl p-6 max-w-md w-full mx-4">
          <h2 class="text-xl font-semibold text-gray-900 mb-4">
            <FormattedMessage id="consent-dialog-title" />
          </h2>

          <p class="text-gray-700 mb-6">
            <FormattedMessage id="consent-dialog-description" />
          </p>

          <div class="flex justify-end space-x-3">
            <button
              onClick={handleDecline}
              class="px-4 py-2 rounded-lg text-base font-bold text-black menu-scroll hover:text-primary dark:text-white dark:hover:text-primary"
            >
              <FormattedMessage id="consent-dialog-decline-button" />
            </button>
            <button
              onClick={handleAccept}
              class="text-white end-2.5 bottom-2.5 rounded-md bg-primary hover:bg-primary/90 font-bold rounded-lg text-sm px-4 py-2"
            >
              <FormattedMessage id="consent-dialog-accept-button" />
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ConsentDialog;
